import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import {GeneralProvider} from "./context/GeneralProvider";
import './App.css';


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <GeneralProvider>
    <App />
    </GeneralProvider>
);

